import React from 'react';
import { useFreeKeys } from '../features/freeKeys/hooks/useFreeKeys';
import { FreeKeysHeader } from '../features/freeKeys/components/FreeKeysHeader';
import { PeriodSelector } from '../features/freeKeys/components/PeriodSelector';
import { KeysTable } from '../features/freeKeys/components/KeysTable';

const FreeKeysPage: React.FC = () => {
  const {
    keys, loading, periodType, setPeriodType,
    periodValue, selectedDate, handleDateChange,
    canViewFull, message
  } = useFreeKeys();

  return (
    <div className="min-h-screen bg-[#f8fafc] p-4 md:p-6 lg:p-8 pb-12">
      <div className="max-w-7xl mx-auto space-y-6">
        <FreeKeysHeader
          message={message}
          canViewFull={canViewFull}
        />

        <PeriodSelector
          periodType={periodType}
          setPeriodType={setPeriodType}
          selectedDate={selectedDate}
          handleDateChange={handleDateChange}
          periodValue={periodValue}
        />

        <KeysTable
          keys={keys}
          loading={loading}
          periodType={periodType}
          canViewFull={canViewFull}
        />
      </div>
    </div>
  );
};

export default FreeKeysPage;
